import { gql } from '@apollo/client';

export const GET_ORDERS = gql`
  query AllOrders(
    $userId: ID!
    $offset: Int
    $limit: Int
    $filters: OrderFilters
  ) {
    allOrders(
      userId: $userId
      offset: $offset
      limit: $limit
      filters: $filters
    ) {
      __typename
      ... on ReadOrdersSuccess {
        code
        totalOrderQuantity
        orders {
          id
          code
          status {
            id
            name
          }
          orderDate
          totalValue
          itemCount
          commerce
        }
      }
      ... on Error {
        code
        message
      }
    }
  }
`;
